import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/logo2.png';
import _imports_1 from '../assets/icon/recharge.png';
import _imports_2 from '../assets/icon/refund.png';
import _imports_3 from '../assets/icon/transfer.png';
import _imports_4 from '../assets/background/my_carousel1.png';
import _imports_5 from '../assets/icon/auth1.png';
import _imports_6 from '../assets/My/Security.png';
import _imports_7 from '../assets/My/Support.png';
import _imports_8 from '../assets/My/About.png';
import _imports_9 from '@/assets/home/GooglePlay.png';
import _imports_10 from '@/assets/home/AppStore.png';

const _withScopeId = n => (_pushScopeId("data-v-c8baa6ea"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "user-container"
};
const _hoisted_2 = {
  class: "account"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "display": "flex",
    "justify-content": "center",
    "padding": "0 0 10px"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));

const _hoisted_4 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "padding": "0 16px",
    "width": "100%"
  }
};
const _hoisted_5 = {
  class: "wallet-option"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));

const _hoisted_9 = {
  class: "card-options"
};
const _hoisted_10 = {
  class: "title"
};
const _hoisted_11 = {
  class: "des"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  style: {
    "width": "100%",
    "padding": "0 15px"
  }
}, null, -1));

const _hoisted_13 = {
  class: "custom-cell",
  style: {
    "display": "flex",
    "justify-content": "space-between"
  }
};
const _hoisted_14 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5
}, null, -1));

const _hoisted_16 = {
  style: {
    "color": "#d1514b",
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_17 = {
  key: 0,
  style: {
    "color": "#04AC92"
  }
};
const _hoisted_18 = {
  key: 1,
  style: {
    "color": "#d1514b"
  }
};
const _hoisted_19 = {
  key: 2,
  style: {
    "color": "#d1514b"
  }
};
const _hoisted_20 = {
  key: 3,
  style: {
    "color": "#d1514b"
  }
};
const _hoisted_21 = {
  key: 1
};
const _hoisted_22 = {
  class: "custom-cell"
};

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6
}, null, -1));

const _hoisted_24 = {
  class: "custom-cell"
};

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7
}, null, -1));

const _hoisted_26 = {
  class: "custom-cell"
};

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8
}, null, -1));

const _hoisted_28 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "center",
    "padding": "0 16px",
    "margin-top": "30px"
  }
};

const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: "",
  style: {
    "width": "100%"
  }
}, null, -1));

const _hoisted_30 = [_hoisted_29];

const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: "",
  style: {
    "width": "100%"
  }
}, null, -1));

const _hoisted_32 = [_hoisted_31];
import { ref, onActivated, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import 'vant/es/toast/style';
import { Toast } from 'vant';
import { useI18n } from "vue-i18n";
import { userInfo } from '@/apis';
import { Dialog } from 'vant';
export default {
  __name: 'UserView',

  setup(__props) {
    const {
      t
    } = useI18n();
    const router = useRouter();
    const store = useStore();
    const authStatus = ref(null);
    const authLoading = ref(true);
    const email = computed({
      get() {
        return store.state.email.split("@")[0].slice(0, 4) + '***' + '@' + store.state.email.split("@")[1];
      }

    });

    const routerPush = routerName => {
      if (store.state.token !== '') {
        router.push({
          name: routerName
        });
        return;
      }

      router.push({
        name: 'login'
      });
    };

    onActivated(() => {
      if (store.state.token !== '') {
        init().finally(() => {
          if (authLoading.value) {
            authLoading.value = false;
          }
        });
      }
    });

    const checkLogin = () => {
      if (store.state.token === '') {
        router.push({
          name: 'login'
        });
      }
    };

    const authRouter = () => {
      if (store.state.token === '') {
        router.push({
          name: 'login'
        });
        return;
      }

      if (authStatus.value) {
        switch (authStatus.value) {
          case 3:
            router.push({
              name: 'identityAuth'
            });
            break;

          case 2:
            router.push({
              name: 'authInfo'
            });
            break;

          case 1:
            router.push({
              name: 'identityAuth'
            });
            break;
        }
      } else {
        router.push({
          name: 'identityAuth'
        });
      }
    };

    const init = async () => {
      const res = await userInfo({});
      authStatus.value = res.data.authState;
    };

    const goToTq = () => {
      Dialog({
        title: 'Email',
        message: 'support@ftzcoininc.com',
        confirmButtonText: t('confirmText')
      });
    };

    const logout = () => {
      store.commit('tokenChange', '');
      store.commit('emailChange', '');
      localStorage.removeItem('astore_info');
      Toast({
        message: t('logoutSuccess'),
        position: 'bottom'
      });
    };

    const download = () => {
      //网页链接合成
      let address = '';
      let arr = window.location.host.split('.');

      if (arr.length == 3 && arr[0] == 'pc') {
        address = arr[1] + '.' + arr[2];
      } else if (arr.length == 3 && arr[0] == 'www') {
        address = arr[1] + '.' + arr[2];
      } else {
        address = arr[0] + '.' + arr[1];
      }

      window.location.href = 'https://' + address + '/FTZINC.apk';
    };

    const download1 = () => {
      // //网页链接合成
      let address = '';
      let arr = window.location.host.split('.');

      if (arr.length == 3 && arr[0] == 'pc') {
        address = arr[1] + '.' + arr[2];
      } else if (arr.length == 3 && arr[0] == 'www') {
        address = arr[1] + '.' + arr[2];
      } else {
        address = arr[0] + '.' + arr[1];
      }

      window.location.href = 'https://' + address + '/download/FTZCOIN.mobileconfig'; // window.location.href = 'https://apps.apple.com/us/app/ftzc/id6759857278';
    };

    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");

      const _component_van_nav_bar = _resolveComponent("van-nav-bar");

      const _component_van_button = _resolveComponent("van-button");

      const _component_van_loading = _resolveComponent("van-loading");

      const _component_van_cell = _resolveComponent("van-cell");

      const _component_a_button = _resolveComponent("a-button");

      const _component_van_cell_group = _resolveComponent("van-cell-group");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
        border: false,
        "safe-area-inset-top": true,
        fixed: true,
        placeholder: true
      }, {
        left: _withCtx(() => [_createVNode(_component_van_icon, {
          name: "arrow-left",
          size: "20",
          style: {
            "color": "black"
          },
          onClick: _cache[0] || (_cache[0] = $event => _unref(router).push({
            name: 'home'
          }))
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_unref(store).state.token !== '' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(_toDisplayString(_unref(email)), 1)], 64)) : _createCommentVNode("", true)]), _unref(store).state.token === '' ? (_openBlock(), _createBlock(_component_van_button, {
        key: 0,
        type: "primary",
        size: "small",
        onClick: checkLogin,
        style: {
          "--van-button-small-height": "35px",
          "--van-button-small-padding": "0 20px",
          "background-color": "#707A8A",
          "border-color": "#707A8A",
          "color": "white"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('fastLogin')), 1)]),
        _: 1
      })) : _createCommentVNode("", true), _unref(store).state.token === '' ? (_openBlock(), _createBlock(_component_van_button, {
        key: 1,
        type: "primary",
        size: "small",
        onClick: _cache[1] || (_cache[1] = $event => _unref(router).push({
          name: 'register'
        })),
        style: {
          "--van-button-small-height": "35px",
          "--van-button-small-padding": "0 20px",
          "background-color": "var(--text-color)",
          "border-color": "var(--text-color)",
          "color": "var(--bg-color)"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('register')), 1)]),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: "option-item",
        onClick: _cache[2] || (_cache[2] = $event => routerPush('recharge'))
      }, [_hoisted_6, _createElementVNode("div", null, _toDisplayString(_unref(t)('recharge')), 1)]), _createElementVNode("div", {
        class: "option-item",
        onClick: _cache[3] || (_cache[3] = $event => routerPush('withdraw'))
      }, [_hoisted_7, _createElementVNode("div", null, _toDisplayString(_unref(t)('withdraw')), 1)]), _createElementVNode("div", {
        class: "option-item",
        onClick: _cache[4] || (_cache[4] = $event => routerPush('transfer'))
      }, [_hoisted_8, _createElementVNode("div", null, _toDisplayString(_unref(t)('transfer')), 1)])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
        class: "option-item",
        style: {
          "background-image": "linear-gradient(to right ,#5bbc51,#228B22)"
        },
        onClick: goToTq
      }, [_createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('contact')), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('contactDes')), 1)])]), _hoisted_12, _createVNode(_component_van_cell_group, {
        border: false
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell, {
          border: false,
          "is-link": "",
          onClick: authRouter
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", null, _toDisplayString(_unref(t)('auth')), 1)]), _createElementVNode("div", _hoisted_16, [_unref(store).state.token !== '' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [authLoading.value ? (_openBlock(), _createBlock(_component_van_loading, {
            key: 0,
            size: "18"
          })) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [authStatus.value === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(t)('authSuccess')), 1)) : authStatus.value === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(t)('noPass')), 1)) : authStatus.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(t)('authCommit')), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(t)('onAuth')), 1))], 64))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(t)('onLogin')), 1))])])]),
          _: 1
        }), _createVNode(_component_van_cell, {
          border: false,
          "is-link": "",
          onClick: _cache[5] || (_cache[5] = $event => routerPush('passwordManage'))
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", null, _toDisplayString(_unref(t)('securitySet')), 1)])]),
          _: 1
        }), _createVNode(_component_van_cell, {
          border: false,
          "is-link": "",
          onClick: _cache[6] || (_cache[6] = $event => _unref(router).push({
            name: 'agreeList'
          }))
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", null, _toDisplayString(_unref(t)('userAgree')), 1)])]),
          _: 1
        }), _createVNode(_component_van_cell, {
          border: false,
          "is-link": "",
          onClick: _cache[7] || (_cache[7] = $event => _unref(router).push({
            name: 'aboutUs'
          }))
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("div", null, _toDisplayString(_unref(t)('aboutUs')), 1)])]),
          _: 1
        }), _unref(store).state.token !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_a_button, {
          type: "primary",
          danger: "",
          onClick: logout,
          style: {
            "width": "100%",
            "height": "45px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('logout')), 1)]),
          _: 1
        })])) : _createCommentVNode("", true)]),
        _: 1
      }), _createElementVNode("div", {
        class: "btn",
        style: {
          "display": "flex",
          "justify-content": "center",
          "padding": "20px 0 30px"
        }
      }, [_createElementVNode("div", {
        style: {
          "width": "35%",
          "margin-right": "20px"
        },
        onClick: download
      }, _hoisted_30), _createElementVNode("div", {
        style: {
          "width": "35%"
        },
        onClick: download1
      }, _hoisted_32)])]);
    };
  }

};